// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LCpSJPXtMX_RJEWYWZLM{height:100%;display:flex;position:relative;overflow-y:auto}.K9dzR4gUlngaxQtPhMoH{flex-direction:column;width:760px;margin-top:38px;display:flex;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `LCpSJPXtMX_RJEWYWZLM`,
	"content": `K9dzR4gUlngaxQtPhMoH`
};
export default ___CSS_LOADER_EXPORT___;
